import React from 'react'

export default function LogoutImg() {
  return (
    <div>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.8333 7.32292V5.48958C12.8333 5.00335 12.6402 4.53704 12.2964 4.19322C11.9525 3.8494 11.4862 3.65625 11 3.65625H4.58333C4.0971 3.65625 3.63079 3.8494 3.28697 4.19322C2.94315 4.53704 2.75 5.00335 2.75 5.48958V16.4896C2.75 16.9758 2.94315 17.4421 3.28697 17.7859C3.63079 18.1298 4.0971 18.3229 4.58333 18.3229H11C11.4862 18.3229 11.9525 18.1298 12.2964 17.7859C12.6402 17.4421 12.8333 16.9758 12.8333 16.4896V14.6563" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M6.41663 10.9902H19.25M19.25 10.9902L16.5 8.24023M19.25 10.9902L16.5 13.7402" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    </div>
  )
}
